export default {
  dashboardMetadata: {
    titles: {
      competencies360: 'Компетенции (по 360)',
      knowledge: 'Знания',
      personalPotential: 'Личностный потенциал',
      conflictLevel: 'Уровень конфликтности',
      managementStyle: 'Стиль менеджмента (Адизес)',
      teamRoles: 'Роли в команде (Белбин)',
      targets: 'Цели',
      feedbacks: 'Фидбэки',
      proposeRoadmap: 'Инициация ИПР',
    },
    descriptions: {
      proposeRoadmap: 'Заполните все обязательные поля формы.',
    },
    formLabels: {
      proposeRoadmapWhy: 'Почему хочу создать ИПР',
      proposeRoadmapSubject: 'Что хочу развить',
      proposeRoadmapResult: 'Какой результат хочу получить',
      proposeRoadmapDeadline: 'Желаемый срок выполнения',
    },
    personal: {
      managementStyles: {
        unusual: 'Несвойственный стиль',
        lackOfTrends: 'Отсутствие тенденций',
        moderate: 'Умеренное выражение стиля',
        vivid: 'Яркая выраженность стиля',
      },
      potential: {},
      teamRoles: {
        preferredRoles: 'Наиболее приемлемые',
        unwantedRoles: 'Наименее приемлемые',
      },
    },
    companyNotSelected:
      'Компания не выбрана. Для отображения профиля, выберите компанию с помощью кнопки «Изменить»',
    welcome: 'Добро пожаловать в HRChain',
    completedAdaptation: 'Завершим адаптацию?',
    congratulations: 'Поздравляю!',
    newAdaptationPlan: 'Для тебя подготовлен </br> новый план адаптации',
    adaptationPlanPrepared: 'Для тебя подготовлен план адаптации',
    processedDeadlineAdaptation: 'Дедлайн адаптации: ',
    processedDeadlineTask: 'Дедлайн задачи: ',
    adaptationCompleted: 'Адаптация завершена',
    goAdaptationButton: 'Приступить к адаптации',
    goPlanButton: 'Перейти к плану',
    goTasksButton: 'Перейти к задачам',
    noDeadline: 'отсутствует',
    roadmapUntil: 'до',
    tooltips: {
      self: 'Самооценка - оценки оцениваемого пользователя',
      supervisor: 'Руководители - оценки пользователей в роли «Руководитель»',
      experts: 'Все без самооценки',
      proposeRoadmapDisabled:
        'Предложить план развития пока нельзя: согласовать план и принять его выполнение некому. Для этого у вас должен быть назначен руководитель или лидер команды — кто-то, кроме вас самих. Обратитесь к организатору вашей компании, он поможет с настройкой.',
    },
    dynamicsOfChanges360: 'Динамика изменений оценки 360',
    defaultPeriodYear: 'За последние 12 месяцев',
    noDataPeriod: 'Отсутствуют данные за выбранный период',
    yourFeedback: 'Ваша лента фидбэков',
    // messages
    successMessages: {
      changeMetadataUser: 'Данные профиля успешно изменены',
      deleteAttachment: 'Вложение успешно удалено',
    },
    errorMessages: {
      getFeedbackData: 'Не удалось получить данные о фидбэке',
      diagramInNotAvailable: 'Отсутствуют данные по коммуникациям',
      getAvailabilityDiagram: 'Не удалось проверить доступность диаграммы',
      getVariantsPersonalReport: 'Не удалось получить варианты отчётов',
      getLinkPersonalReport: 'Не удалось получить ссылку на отчёт',
      roadmaps: 'Не удалось получить данные по доске задач',
      adaptations: 'Не удалось получить данные по задачам адаптации',
      getTargetList: 'Не удалось получить список целей',
      changeMetadataUser: 'Не удалось изменить данные профиля',
      changeAvatar: 'Не удалось загрузить аватар',
      changeSpecialization: 'Не удалось изменить специализации',
      deleteAttachment: 'Не удалось удалить вложение',
      updateCompany: 'Не удалось обновить список компаний',
      emailConflict: 'Такой email уже используется',
      proposeRoadmap: 'Не удалось предложить ИПР',
    },
    competenceGroups: {
      emotional: 'Эмоциональные компетенции',
      volitional: 'Волевые компетенции',
      social: 'Социальные компетенции',
      cognitive: 'Когнитивные компетенции',
    },
    // confirm dialogs
    confirmGetReport: {
      title: 'Сформировать отчет?',
      text: 'Не все участники теста заполнили опросник, полученные данные могут оказаться недостоверными.',
      button: 'Да, сформировать',
    },
    confirmDeleteAttachment: 'Удалить вложение?',
    inQueue: 'в очереди',
    pageDevelopmentPlans: 'Страница для работы с задачами из планов развития',
    new: 'Новая',
    inProgress: 'В работе',
    done: 'Готово',
    overdue: 'Просрочено',
    totalTargets: 'всего целей',
    efficiency: 'эффективность',
    noData: 'Отсутствуют данные по целям',
    sendLink: 'Отправить',
    sendLinkHint: 'Выслать письмо для создания пароля',
    sendLinkTitle: 'Отправить письмо',
    sendLinkBody:
      'Отправить письмо с ссылкой на создание пароля на новый e-mail адрес пользователя?',
    successMsg: 'Ссылка отправлена пользователю',
    errorMsg: 'Что-то пошло не так',
  },
};
